import * as React from 'react';
const SvgTicIcon = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={19}
    height={14}
    fill="none"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}>
    <path d="m17.378 1.75-10.5 10.5L1.628 7" />
  </svg>
);
export default SvgTicIcon;
